import {Injectable} from '@angular/core';
import {ParentService} from "./ParentService";
import {LibraryFolderEntity} from "../model/LibraryFolderEntity";
import {LibraryEntity} from "../model/LibraryEntity";
import {VideoEntity} from "../model/VideoEntity";
import {VideoFolderEntity} from "../model/VideoFolderEntity";
import {VideoCommentEntity} from "../model/VideoCommentEntity";
import {JustReferenceDto} from "../dto/JustReferenceDto";
import {catchError} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {VideoPlaylistEntity} from "../model/VideoPlaylistEntity";
import {VideoPlaylistVideoEntity} from "../model/VideoPlaylistVideoEntity";
import {VideoQuestionDto} from "../dto/VideoQuestionDto";

@Injectable()
export class VideoService extends ParentService{

  public getVideoFolders(obj){
      return this.http.post<VideoFolderEntity[]>(this.shared.MAGNAMENT_URL+'/getVideoFolders', obj, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getVideoFolder(corpId){
    return this.http.get<VideoFolderEntity[]>(this.shared.MAGNAMENT_URL+'/getVideoFolders/'+corpId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getVideos(vidFolderId){
    return this.http.get<VideoEntity[]>(this.shared.MAGNAMENT_URL+'/getVideos/'+vidFolderId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveVideoFolder(folder){
    return this.http.post<VideoFolderEntity>(this.shared.MAGNAMENT_URL+'/saveVideoFolder',folder, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveVideo(video){
    return this.http.post<VideoEntity>(this.shared.MAGNAMENT_URL+'/saveVideo/'+this.shared.CORP_ID,video, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getVideoQuestions(videoId, videoFolderId){
    return this.http.get<VideoQuestionDto[]>(this.shared.MAGNAMENT_URL+'/getVideoQuestions/'+videoId+'/'+videoFolderId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveVideoQuestion(videoQuestion){
    return this.http.post<VideoQuestionDto>(this.shared.MAGNAMENT_URL+'/saveVideoQuestion', videoQuestion, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public deleteVideoQuestion(id){
    return this.http.get<void>(this.shared.MAGNAMENT_URL+'/deleteVideoQuestion/'+id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getVideo(reference){
    return this.http.get<VideoEntity>(this.shared.MAGNAMENT_URL+'/getVideo/'+reference, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getAllVideos(corpId){
    return this.http.get<VideoEntity[]>(this.shared.MAGNAMENT_URL+'/getAllVideos/'+corpId, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public searchAllVideos(obj){
    return this.http.post<VideoEntity[]>(this.shared.MAGNAMENT_URL+'/searchAllVideos', obj, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public updateVideoByTitle(title){
    return this.http.get<JustReferenceDto>(this.shared.MAGNAMENT_URL+'/updateVideoByTitle/'+title+'/'+this.shared.CORP_ID, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public uploadVideoToVimeo(file, title){
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post<JustReferenceDto>(this.shared.MAGNAMENT_URL+'/uploadVideo/'+title+'/'+this.shared.CORP_ID, formData, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public uploadTranscriptionDocument(file){
    const formData = new FormData();
    formData.append("file", file);
    return this.http.post<JustReferenceDto>(this.shared.MAGNAMENT_URL+'/uploadTranscriptionDocument', formData, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }




  public getVideoPlaylist(){
    return this.http.get<VideoPlaylistEntity[]>(this.shared.MAGNAMENT_URL+'/getVideoPlaylist/'+this.shared.CORP_ID, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public getVideoItems(id){
    return this.http.get<VideoPlaylistVideoEntity[]>(this.shared.MAGNAMENT_URL+'/getVideoPlaylistItems/'+id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveVideoPlaylist(videoPlaylist){
    return this.http.post<VideoPlaylistEntity>(this.shared.MAGNAMENT_URL+'/saveVideoPlaylist',videoPlaylist, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public saveVideoItem(videoItem){
    return this.http.post<VideoPlaylistVideoEntity>(this.shared.MAGNAMENT_URL+'/saveVideoItem',videoItem, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public savePlayListItems(playlistItems){
    return this.http.post<VideoPlaylistVideoEntity>(this.shared.MAGNAMENT_URL+'/saveVideoItems',playlistItems, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

  public deleteVideoItem(id){
    return this.http.get<any>(this.shared.MAGNAMENT_URL+'/deleteVideoItem/'+id, this.shared.headers()).pipe(catchError((error: HttpErrorResponse) => this.shared.handleError(error)));
  }

}
